import React, { useState } from "react";
import "assets/styles/common/ContactForm.scss";

const ContactForm = () => {
  const [values, setValues] = useState({
    name: "",
    email: "",
    telephone: "",
    comments: "",
    emailtype: 1
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        "https://appservices.next-cloud.mx/rest/services/pipeline/venders/internet/1/send/email/",
        {
          method: "POST",
          headers: {
            "accept": "application/json",
            "content-type": "application/json; charset=utf-8"
          },
          body: JSON.stringify(values)
        }
      );
      const data = await response.json();
      setValues({
        name: "",
        email: "",
        telephone: "",
        comments: "",
        emailtype: 1
      });
      alert(data.msg);
    } catch (e) {
      alert("Ocurrió un error al enviar el mensaje");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className={'contactFormWrapper'}>
      <div className={'contactFormContainer'}>
        <div className={'contactFormHeader'}>
          <h3>¿Tienes dudas o necesitas más información?</h3>
          <p>
            Completa el formulario o escríbenos directamente a{" "}
            <a href="mailto:comercial@etomin.com">comercial@etomin.com</a>
          </p>
        </div>

        <form onSubmit={handleSubmit} className={'contactForm'}>
          <div className={'formGroup'}>
            <input
              type="text"
              name="name"
              value={values.name}
              onChange={handleChange}
              placeholder="Nombre"
              required
            />
          </div>

          <div className={'formGroup'}>
            <input
              type="email"
              name="email"
              value={values.email}
              onChange={handleChange}
              placeholder="Correo electrónico"
              required
            />
          </div>

          <div className={'formGroup'}>
            <input
              type="tel"
              name="telephone"
              value={values.telephone}
              onChange={handleChange}
              placeholder="Teléfono"
              required
            />
          </div>

          <div className={'formGroup'}>
            <textarea
              name="comments"
              value={values.comments}
              onChange={handleChange}
              placeholder="Mensaje"
              rows="5"
              required
            />
          </div>

          <button type="submit" className={'submitButton'}>
            Enviar mensaje
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
